import dayjs from "../shared/helpers/dayjs";
import { gaEvent } from "../shared/helpers/gtm_tracking";
import windowSize from "../shared/helpers/window_size";

import { PICKADATE_UK_DATE_FORMAT, UK_DATE_FORMAT } from "../const/DateFormatConsts";

module.exports = {
  regularPickerOptions(container, changeHandler = function () {}) {
    const $container = $(container);

    return {
      container: ($container.length && $container) || undefined,
      weekdaysShort: ["S", "M", "T", "W", "T", "F", "S"],
      format: PICKADATE_UK_DATE_FORMAT,
      today: false,
      close: "Cancel",
      firstDay: true,
      min: 1,
      onSet(eventOptions) {
        if ("clear" in eventOptions || "select" in eventOptions) {
          const date = dayjs(this.get(), UK_DATE_FORMAT);

          changeHandler(date.isValid() ? date : null);
          if (windowSize.isHandheld()) {
            const offersCount = document.getElementById("js-offers-count");

            if (offersCount) {
              offersCount.scrollIntoView();
            }
          }
        }
      }
    };
  },

  pricedPickerOptions(id, changeHandler, pricingData) {
    const dateContainer = document.querySelector(`[data-id="${id}"] .js-offer-date-container`);

    return {
      klass: { picker: "picker picker--priced" },
      weekdaysShort: ["S", "M", "T", "W", "T", "F", "S"],
      format: PICKADATE_UK_DATE_FORMAT,
      today: false,
      clear: false,
      close: "Cancel",
      container: `.js-pickadate-container-${id}`,
      firstDay: true,
      min: 1,
      disable: [true].concat(Object.keys(pricingData.day_prices).map(date => new Date(date))),
      onOpen() {
        gaEvent("Venue Page", "Package", "Change Date");
        dateContainer.classList.add("is-open");
      },
      onClose() {
        setTimeout(function () {
          dateContainer.classList.remove("is-open");
        }, 500);
      },
      onStart() {
        this.component.updatePricingData(pricingData);
      },
      onSet(eventOptions) {
        if ("select" in eventOptions) {
          const date = dayjs(this.get(), UK_DATE_FORMAT);

          changeHandler(date.isValid() ? date : null, this.component);
        }
      }
    };
  }
};



// WEBPACK FOOTER //
// ./utils/DatePickerSupport.js